import React from "react";
import { Guidance } from "components/guidance";

export const ErrorPage = () => {
  return (
    <div style={{padding: "30px"}} className="error-page">
      <Guidance
        displayMode={"inline"}
        type="warning"
        content={
          <>
            <p>Hello, it looks like our system doesn't recognize you.</p>
            <p>Make sure to enable popups for this site.</p>
            <p>If you need to request access, please notify a RFI Administrator at <a href={"mailto: rfi@pnnl.gov"}>rfi@pnnl.gov</a>.</p>
          </>
        }
        bgIconSize="sm"
        heading={"Unable to Login"}
        />
    </div>
  )
};
